// extracted by mini-css-extract-plugin
export var notificationHost = "_fy-0";